import { render, staticRenderFns } from "./vMadeWithMovement.vue?vue&type=template&id=2408e3fe&scoped=true&"
import script from "./vMadeWithMovement.vue?vue&type=script&lang=js&"
export * from "./vMadeWithMovement.vue?vue&type=script&lang=js&"
import style0 from "./vMadeWithMovement.vue?vue&type=style&index=0&id=2408e3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408e3fe",
  null
  
)

export default component.exports